import { render, staticRenderFns } from "./MultiImg.vue?vue&type=template&id=308362ad"
import script from "./MultiImg.vue?vue&type=script&lang=js"
export * from "./MultiImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@6.26.3_cache-loader@4.1.0_webpac_ddacfd63a0804571a953918ce6bcb0d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports